import { api } from "../../api";

export const favoritesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createFavorite: builder.mutation({
      query: ({ videoId }) => ({
        url: "/favorites/create",
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ videoId }).toString(),
      }),
    }),
    deleteFavorite: builder.mutation({
      query: ({ videoId }) => ({
        url: "/favorites/delete",
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ videoId }).toString(),
      }),
    }),
    getAllFavorites: builder.query({
      query: () => ({
        url: "/favorites/getall",
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateFavoriteMutation,
  useDeleteFavoriteMutation,
  useGetAllFavoritesQuery,
} = favoritesApi;
